import React from 'react';
import ReactDOM from 'react-dom/client'; // ¡Importante: cambiar a 'react-dom/client'
import App from './App';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root')); // Crear una raíz
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);